import $ from 'jquery';
import {
    ALLOWED_KEYS,
    ATTR,
    CLASSNAMES,
    FILTER_PARAMS,
    NUMERIC_INPUTS,
    SELECTORS,
    createFilterState,
    escapeAttrValue
} from './filters.state';
import {
    addApplyFiltersButton,
    addClearFiltersButton,
    bindEvents,
    collapseDuplicateFilterLabels,
    disableFilterControls,
    getCurrentDelivery,
    getCurrentWarehouse,
    getFilterGroupSelectedContainer,
    getFilterMaxPrice,
    getFilterMinPrice,
    getFilterForm,
    getFloatingFilterSubmit,
    getFloatingSelectedSubmit,
    getSelectedFilterTitle,
    getSidebarFilterOffset,
    initRangeSliders,
    normalizePrefixedInputs,
    parseFiltersFromDOM,
    readPriceBoundsFromDom,
    processFilterPriceInput,
    processRangeSlideAction,
    resetFiltersUI,
    sanitizeRangeInput,
    updateClearAllButton,
    updateMobileFilters
} from './filters.view';
import { serializeFiltersToQuery } from './filters.adapters';

/**
 * Инициализировать модуль фильтров товаров.
 */
const initProductFilters = () => {
    const state = createFilterState();

    const isFiltersUnchanged = () => {
        const keys1 = Object.keys(state.initialFilters);
        const keys2 = Object.keys(state.modifiedFilters);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (const key of keys1) {
            if (!Object.prototype.hasOwnProperty.call(state.modifiedFilters, key)) {
                return false;
            }
        }

        for (const key of keys2) {
            if (!Object.prototype.hasOwnProperty.call(state.initialFilters, key)) {
                return false;
            }
        }

        return (
            state.initialPrices[0] == getFilterMinPrice(state) &&
            state.initialPrices[1] == getFilterMaxPrice(state) &&
            state.initialDelivery == getCurrentDelivery() &&
            state.initialWarehouse == getCurrentWarehouse()
        );
    };

    const updateModalFooterFloating = () => {
        $(SELECTORS.modalFooter).toggleClass(CLASSNAMES.modalFooterFloating, !isFiltersUnchanged());
    };

    const updateFloatingButtons = () => {

        const submitBtn = getFloatingSelectedSubmit();

        if( isFiltersUnchanged() ) {
            submitBtn.fadeOut().removeClass( CLASSNAMES.floatingButtonSimple );            
        } else {
            submitBtn.fadeIn();
            getFloatingFilterSubmit().css('pointer-events', 'none').animate({ opacity: 0 }, 250);

            setTimeout( function() {
                const anyFilters = $( `[${ATTR.linkedFilter}]` ).length > 0;
                submitBtn.toggleClass( CLASSNAMES.floatingButtonSimple, ! anyFilters );
            }, 0 );
        }            
    };

    const syncPriceBoundsFromDom = () => {
        const bounds = readPriceBoundsFromDom();
        if (bounds) {
            state.priceMin = bounds.min;
            state.priceMax = bounds.max;
        }
    };

    const removeSelectedFilterFromGroup = (button, filterType) => {
        $(`[${ATTR.filterGroup}="${escapeAttrValue(filterType)}"]`).each( function() {
            $(this).find(SELECTORS.formCheckInput).prop('checked', false);
            if ($(this).closest(SELECTORS.modalFilter).length > 0) {
                //selectedButtons.remove();
            } else {
                const selectedButtons = $(this).find(`.btn[${ATTR.filterId}]`);
                selectedButtons.removeClass(CLASSNAMES.activeButton);
            }
        });
        
        button.closest(SELECTORS.mainContents).find(`[${ATTR.filterType}="${escapeAttrValue(filterType)}"]`).remove();
    };

    const handleSelectedFilterRemoval = event => {
        const button = $(event.currentTarget);
        const filterIds = button.attr(ATTR.linkedFilter).split(',');

        filterIds.forEach( filterId => {
            const fidSel = `[${ATTR.filterId}="${filterId}"]`;
            const fidLinkedSel = `[${ATTR.linkedFilter}="${filterId}"]`;

            $(`input${fidSel}`).prop('checked', false);
            $(`.btn${fidSel}`).removeClass(CLASSNAMES.activeButton);
            
            $(`${SELECTORS.modalFilter} .btn${fidLinkedSel}`).remove();

            if (typeof state.modifiedFilters[filterId] !== 'undefined') {
                delete state.modifiedFilters[filterId];
            }
        });
        
        if (button.closest(`[${ATTR.filtersCompact}]`).length > 0) {
            const filterType = button.attr(ATTR.filterType);
            removeSelectedFilterFromGroup(button, filterType);
        }

        updateModalFooterFloating();
        button.remove();
        updateFloatingButtons();
        collapseDuplicateFilterLabels();
        updateMobileFilters(state);
        updateClearAllButton();
    };

    const buildSelectedFilterButton = (filterValueText, filterTypeText, filterId, btnClass, position ) => {
        return $('<button>')
            .addClass(`${CLASSNAMES.selectedButton} ${btnClass}`)
            .text(filterValueText)
            .attr(ATTR.linkedFilter, filterId)
            .attr(ATTR.filterType, filterTypeText)
            .attr(ATTR.filterCount, 1)
            .css('order', position )
            .on('click', handleSelectedFilterRemoval);
    };

    const appendSelectedFilterButton = (container, filterTypeText, filterId, button) => {
        let isRadio = filterTypeText == 'Доставка';
        if( filterId ) {
            container.find(`[${ATTR.linkedFilter}=${filterId}]:not([${ATTR.filterType}])`).remove();
            isRadio = $(`[${ATTR.filterId}="${filterId}"][type="radio"]`).length > 0;
        }

        if (container.attr(ATTR.filtersCompact) > 0) {

            const selExistingType = `[${ATTR.filterType}="${escapeAttrValue(filterTypeText)}"]`;
            let existingType = container.find(selExistingType + ':eq(0)');            

            if( isRadio ) {
                $(selExistingType.replace( /=/, '^=')).remove();
                const radioFilterLabel = $(
                    `[${ATTR.filterId}="${filterId}"] ~ .form-check-label`
                ).first().text().toLowerCase();

                if(filterId) {
                    button
                        .attr(ATTR.filterType, filterTypeText + ': ' + radioFilterLabel )
                        .text('')
                        .removeAttr(ATTR.filterCount);
                } else {
                    button = $('');
                }
                
                existingType = [];
            }

            if (existingType.length > 0) {
                const linkedFilters = existingType.attr( ATTR.linkedFilter ).split(',');
                ! linkedFilters.includes( filterId ) && linkedFilters.push( filterId );
                ! isRadio && existingType.attr(ATTR.filterCount, linkedFilters.length );
                existingType.attr(ATTR.linkedFilter, linkedFilters.join(','));
            } else {
                container.append(
                    button
                        .clone(true)
                        .removeClass(CLASSNAMES.desktopFilterButton)
                        .addClass(CLASSNAMES.selectedButtonCompact)
                        .text('')
                );
            }
        }

        if (container.attr(ATTR.filtersFull) > 0) {
            const elSelectedFull = (isRadio ? '' : `[${ATTR.linkedFilter}="${filterId}"]`) +
                `[${ATTR.filterType}="${escapeAttrValue(filterTypeText)}"]`;
            
            const existingButton = container.find(elSelectedFull);
            const newButton = button.clone(true);
            if (existingButton.length > 0) {
                existingButton.replaceWith(newButton.first());
            } else {
                container.append(newButton);
            }

            addClearFiltersButton(container, clearSelectedFilters);            
        }
    };

    const setSelectedFilter = (elSelected, btnTextParts, filterId, btnClass, position ) => {
        if (!btnTextParts || btnTextParts.length < 2) {
            return;
        }

        const filterValueText = btnTextParts[1].trim();
        const filterTypeText = btnTextParts[0].trim();
        if (!filterValueText || !filterTypeText) {
            return;
        }
        const filterButton = buildSelectedFilterButton(
            filterValueText, filterTypeText, filterId, btnClass, position 
        );

        elSelected.each(function() {
            appendSelectedFilterButton($(this), filterTypeText, filterId, filterButton);
            state.modifiedFilters[filterId] = 1;
            updateModalFooterFloating();
        });

        window.dispatchEvent(new CustomEvent('recalcMobileFilterHeights'));

        collapseDuplicateFilterLabels();
        updateMobileFilters(state);

        const fidSel = `[${ATTR.filterId}="${filterId}"]`;
        $(`input${fidSel}`).prop('checked', true);
        $(`${SELECTORS.filtersModal} .btn${fidSel}`).addClass(CLASSNAMES.activeButton);
    };

    const unsetSelectedFilter = (elSelectedFilters, btnText) => {
        if (btnText.length > 1 && btnText[1].trim() !== '') {
            const filterName = btnText[0].trim();
            const filterValue = btnText[1].trim();
            const filterButtonSelector = `[${ATTR.filterType}="${escapeAttrValue(filterName)}"]:contains("${escapeAttrValue(filterValue)}")`;

            elSelectedFilters.find(`[${ATTR.linkedFilter}]${filterButtonSelector}`).remove();
            $(`${SELECTORS.filtersModal} ${filterButtonSelector}`).removeClass(CLASSNAMES.activeButton);
        }

        collapseDuplicateFilterLabels();
        updateMobileFilters(state);
        updateClearAllButton();

        window.dispatchEvent(new CustomEvent('recalcMobileFilterHeights'));
    };

    const triggerFilterInputClick = (filterId, initInput) => {
        const filterSel = `[${ATTR.filterId}="${filterId}"]`;
        const activeFilter = initInput.is('button')
            ? !initInput.hasClass('active')
            : initInput.prop('checked');
        let currFilterEl = false;

        FILTER_PARAMS.forEach(filterConfig => {
            const currentContainer = filterConfig.container;
            if ($(currentContainer).length > 0) {
                $(currentContainer).find(filterSel).each(function() {
                    const elSelectedFilters = getFilterGroupSelectedContainer(filterConfig, $(this));
                    const btnTextParts = getSelectedFilterTitle($(this));
                    const position = $(this).attr( ATTR.filterPosition );

                    if ($(this).is('button')) {
                        $(this).toggleClass(CLASSNAMES.activeButton, activeFilter);
                    } else {
                        if ($(this).closest(SELECTORS.filterForm).length > 0) {
                            currFilterEl = $(this);
                        }

                        if (!$(this).is(initInput)) {
                            $(this).prop('checked', activeFilter);
                        }

                        const filterAccordion = $(this).closest( SELECTORS.accordionItem );
                        filterAccordion.siblings( SELECTORS.accordionItem ).removeAttr( ATTR.filterLastChanged );
                        filterAccordion.attr( ATTR.filterLastChanged, $(this).attr( ATTR.filterId ))
                    }

                    if (activeFilter) {
                        setSelectedFilter(elSelectedFilters, btnTextParts, filterId, filterConfig.buttonClass, position );
                    } else {
                        unsetSelectedFilter(elSelectedFilters, btnTextParts);
                    }
                });
            }
        });

        if (activeFilter) {
            state.modifiedFilters[filterId] = 1;
        } else if (typeof state.modifiedFilters[filterId] !== 'undefined') {
            delete state.modifiedFilters[filterId];
        }

        updateModalFooterFloating();
        if (currFilterEl) {
            slideFilterFormButton(currFilterEl);
        }
    };

    const slideFilterFormButton = ( elFilter, lastInteracted ) => {
        const floatingSubmit = getFloatingFilterSubmit();
        const floatingSelectedSubmit = getFloatingSelectedSubmit();
        const isMobile = $(window).width() <= 992;

        if (floatingSubmit.length === 0) {
            return;
        }

        if (isFiltersUnchanged()) {
            floatingSubmit.css('pointer-events', 'none').animate({ opacity: 0 }, 250, 'swing', () => {
                floatingSubmit.css({ top: getSidebarFilterOffset(elFilter, lastInteracted) });
                state.filterButtonInited = false;
            });
            //floatingSelectedSubmit.fadeOut();
            return;
        } else {
            //floatingSelectedSubmit.fadeIn();
        }

        const now = Date.now();
        if (now - state.lastSlideButtonTime < 200) {
            return;
        }

        state.lastSlideButtonTime = now;
        if (!elFilter) {
            return;
        }

        const topOffset = getSidebarFilterOffset(elFilter, lastInteracted );
        const currentTop = parseFloat(floatingSubmit.css('top'));
        const farDistance = Math.abs(topOffset - currentTop) > 300;

        if (topOffset > 0) {
            if (!state.filterButtonInited && farDistance) {
                floatingSubmit.css({ top: topOffset + 259 });
            }

            floatingSubmit.css('pointer-events', 'auto').animate({ top: topOffset, opacity: 1 }, 350);
            floatingSelectedSubmit.fadeOut();
            state.filterButtonInited = true;
        } else {
            updateFloatingButtons();
        }

    };

    const resetFilters = el => {
        resetFiltersUI(state, el);
        /*! isFiltersUnchanged() && */$(SELECTORS.filterOptionsSubmit).click();
    };

    const clearSelectedFilters = event => {
        event.preventDefault();
        $(SELECTORS.filterSelected).each(function() {
            $(SELECTORS.filterButtons).removeClass(CLASSNAMES.activeButton);
            $(SELECTORS.filterInputs).prop('checked', false);

            if ($(this).closest(SELECTORS.filtersModal).length === 0) {
                $(this).find(SELECTORS.buttonsWithoutToggle).remove();
            }
        });

        state.modifiedFilters = [];
        resetFilters($(SELECTORS.mainContents + ' ' + SELECTORS.filterOptions));
    };

    const initActiveFilters = () => {
        const activeFilerIdsList = $(`[${ATTR.activeFilters}]`).data('active-filters');

        if (activeFilerIdsList && FILTER_PARAMS.length > 0) {
            FILTER_PARAMS.forEach((filterConfig, index) => {
                if (index === 0) {
                    activeFilerIdsList.toString().split(',').forEach(filterId => {
                        const elFilter = $(
                            `${SELECTORS.formCheckInput}[${ATTR.filterId}="${filterId}"]`
                        );
                        const elSelectedFilters = getFilterGroupSelectedContainer(filterConfig, elFilter);
                        const btnTextParts = getSelectedFilterTitle(elFilter);
                        const position = elFilter.attr( ATTR.filterPosition );
                        setSelectedFilter(
                            elSelectedFilters,
                            btnTextParts,
                            filterId, 
                            filterConfig.buttonClass,
                            position 
                        );
                        state.initialFilters[filterId] = 1;
                    });
                }
            });
        }

        const parsed = parseFiltersFromDOM(state);
        parsed.selectedIds.forEach(filterId => {
            if (!Object.prototype.hasOwnProperty.call(state.initialFilters, filterId) && FILTER_PARAMS.length > 0) {
                const filterConfig = FILTER_PARAMS[0];
                const elFilter = $(
                    `${SELECTORS.formCheckInput}[${ATTR.filterId}="${filterId}"]:checked`
                );
                const elSelectedFilters = getFilterGroupSelectedContainer(filterConfig, elFilter);
                const btnTextParts = getSelectedFilterTitle(elFilter);
                const position = elFilter.attr(ATTR.filterPosition);

                setSelectedFilter(
                    elSelectedFilters,
                    btnTextParts,
                    filterId,
                    filterConfig.buttonClass,
                    position
                );
            }

            state.initialFilters[filterId] = 1;
            state.modifiedFilters[filterId] = 1;
        });
        state.initialPrices = [parsed.priceMin, parsed.priceMax];
    };

    const processInputField = inputConfig => {
        const elInput = $(inputConfig.selector);
        elInput.each(function() {
            if ($(this).val().trim()) {
                const numValue = parseInt($(this).val().replace(/\D/g, ''), 10);
                processFilterPriceInput(state, $(this), numValue, () => updateMobileFilters(state));
            }
        });
    };

    const processInputFieldEvent = (event, inputConfig) => {
        const elInput = $(event.target);
        const allowedCombo = event.ctrlKey && event.which === 65;

        if (event.type === 'keydown') {
            if (!allowedCombo && !ALLOWED_KEYS.includes(event.key) && !/^\d$/.test(event.key)) {
                event.preventDefault();
                return false;
            }

            if (event.key === 'Enter' || event.which === 13) {
                elInput.blur();
            }
        }

        const updateEvent = new RegExp(inputConfig.updateEvent);
        if (updateEvent.test(event.type)) {
            processFilterPriceInput(state, elInput, elInput.val(), () => updateMobileFilters(state));
        }

        slideFilterFormButton(elInput);
        return true;
    };

    const initNumericInputs = () => {
        NUMERIC_INPUTS.forEach(inputConfig => {
            $(inputConfig.selector).each(function() {
                // Per-element guard: обработчики полей цены навешиваем один раз. Нужно
                // для идемпотентного повторного прогона при доинициализации ленивой
                // модалки (её поля появляются позже) — без дублей на десктопных полях.
                if (this.dataset.filtersNumericBound === '1') {
                    return;
                }
                this.dataset.filtersNumericBound = '1';

                $(this)
                    .on('focus', function() {
                        $(this).val($(this).val().replace(/\D/g, ''));
                    })
                    .on('blur keydown keyup', function(event) {
                        processInputFieldEvent(event, inputConfig);
                    });
            });

            processInputField(inputConfig);
        });
    };

    const initFilterAccordions = () => {
        document.querySelectorAll(SELECTORS.filterFormAccordions).forEach(accordion => {
            const collapseEl = document.getElementById(accordion.id);
            if (collapseEl) {
                collapseEl.addEventListener('shown.bs.collapse', () => {
                    slideFilterFormButton(`#${accordion.id}`, true );
                });
                collapseEl.addEventListener('hidden.bs.collapse', () => {
                    slideFilterFormButton(`#${accordion.id}`);
                });
            }
        });
    }

    /**
     * Клики по фасетам (data-filter-id) навешиваем ДЕЛЕГИРОВАННО на document, а не
     * прямым .click() по найденным на момент init элементам. На страницах поиска и
     * «Уценки» модалка фильтров рендерится не инлайн, а грузится лениво в
     * #lazy-modals-root (см. loadLazyModals в CustomerBundle/common.js) уже ПОСЛЕ
     * инициализации модуля — поэтому прямой биндинг к её чекбоксам не привязывался и
     * фильтры в мобильной модалке молча не работали (на десктопе те же фасеты живут в
     * инлайновом .main-contents, поэтому там всё работало). Делегирование ловит и
     * текущие, и лениво добавленные элементы. Селекторы контейнеров (.main-contents /
     * .modal_filter / .modal_filters) взаимоисключающие, поэтому один делегированный
     * обработчик срабатывает по клику ровно один раз. triggerFilterInputClick сам
     * ресинхронизирует состояние по всем контейнерам, так что filterConfig здесь не нужен.
     */
    const initFilterParamHandlers = () => {
        const filterItemSelector = FILTER_PARAMS
            .map(filterConfig => `${filterConfig.container} [${ATTR.filterId}]`)
            .join(', ');

        $(document).on('click', filterItemSelector, event => {
            const filterId = $(event.currentTarget).data('filter-id');
            triggerFilterInputClick(filterId, $(event.currentTarget));
        });
    };

    /**
     * Фильтр «Доставка» — radio-группа (name="filter[]", маркер data-delivery-option)
     * без data-filter-id, поэтому не подхватывается initFilterParamHandlers. Запоминаем
     * стартовое значение и по change показываем плавающую кнопку «Применить» рядом с
     * выбранным пунктом, как у остальных фильтров (slideFilterFormButton + isFiltersUnchanged).
     */
    const initDeliveryFilter = () => {
        state.initialDelivery = getCurrentDelivery();

        $(document).on(
            'change',
            `${SELECTORS.filterForm} input[data-delivery-option], ${SELECTORS.filterFormModal} input[data-delivery-option]`,
            function() {
                const selectedValue = String($(this).val() || '');
                $('input[data-delivery-option]').each(function() {
                    this.checked = String(this.value || '') === selectedValue;
                });

                // data-last-changed имеет смысл только для accordion с data-filter-id;
                // у delivery его нет — снимаем метку, чтобы тоггл аккордеона не позиционировал
                // кнопку относительно устаревшего фильтра.
                $(`${SELECTORS.filterForm} ${SELECTORS.accordionItem}`).removeAttr(ATTR.filterLastChanged);
                slideFilterFormButton($(this));
                updateModalFooterFloating();
            }
        );
    };

    /**
     * Снятие фильтра доставки кликом по крестику чипа выбранного фильтра.
     * Доставка — radio-группа (data-delivery-option) без data-filter-id, поэтому
     * штатный handleSelectedFilterRemoval её не снимает (он ищет input[data-filter-id]).
     * Здесь ловим клик по чипу доставки, переводим radio-группу в «Не важно»
     * (value="") и сабмитим форму фильтров — delivery-токен уходит из URL.
     */
    const initDeliveryFilterChipRemoval = () => {
        $(document).on('click', `[${ATTR.linkedFilter}]`, function(event) {
            const token = String($(this).attr(ATTR.linkedFilter) || '');
            if (token === '') {
                return;
            }

            const isDeliveryChip = $(`input[data-delivery-option][value="${escapeAttrValue(token)}"]`).length > 0;
            if (!isDeliveryChip) {
                return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();

            $('input[data-delivery-option]').each(function() {
                this.checked = (this.value === '');
            });

            getFilterForm().submit();
        });
    };

    /**
     * Фильтр «Наличие на складах» — мульти-селект (name="filter[]", маркер data-warehouse-option)
     * без data-filter-id, поэтому не подхватывается initFilterParamHandlers. По аналогии с доставкой
     * запоминаем стартовый выбор и по change показываем плавающую кнопку «Применить»
     * (slideFilterFormButton + isFiltersUnchanged учитывает state.initialWarehouse).
     */
    const initWarehouseFilter = () => {
        state.initialWarehouse = getCurrentWarehouse();

        $(document).on(
            'change',
            `${SELECTORS.filterForm} input[data-warehouse-option], ${SELECTORS.filterFormModal} input[data-warehouse-option]`,
            function() {
                const selectedValue = String($(this).val() || '');
                const checked = this.checked;
                $('input[data-warehouse-option]')
                    .filter((_, input) => String(input.value || '') === selectedValue)
                    .prop('checked', checked);

                // data-last-changed имеет смысл только для accordion с data-filter-id; у складов его нет.
                $(`${SELECTORS.filterForm} ${SELECTORS.accordionItem}`).removeAttr(ATTR.filterLastChanged);
                slideFilterFormButton($(this));
                updateModalFooterFloating();
            }
        );
    };

    /**
     * Снятие фильтра склада кликом по крестику чипа выбранного фильтра.
     * Склады — чекбоксы (data-warehouse-option) без data-filter-id, поэтому штатный
     * handleSelectedFilterRemoval их не снимает. Ловим клик по чипу (data-linked-filter
     * хранит filter[]-токен), снимаем ТОЛЬКО эту опцию (мульти-селект) и сабмитим форму.
     */
    const initWarehouseFilterChipRemoval = () => {
        $(document).on('click', `[${ATTR.linkedFilter}]`, function(event) {
            const token = String($(this).attr(ATTR.linkedFilter) || '');
            if (token === '') {
                return;
            }

            const input = $(`${SELECTORS.filterForm} input[data-warehouse-option][value="${escapeAttrValue(token)}"]`);
            if (input.length === 0) {
                return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();

            input.prop('checked', false);
            getFilterForm().submit();
        });
    };

    /**
     * + нажатие на кнопку "Сбросить все", которая рендерится в шаблоне     
     */
    const initResetButtons = () => {
        $(SELECTORS.filterOptions).each(function() {
            const elFilterOptions = $(this);
            elFilterOptions.find(SELECTORS.resetInput).click(function(event) {
                event.preventDefault();
                resetFilters(elFilterOptions);
            });
        });

        $(`[${ATTR.clearAll}]`).click( clearSelectedFilters );
    };

    const initSliderClickHandler = () => {
        $(SELECTORS.slider).each(function() {
            // Per-element guard — трек слайдера модалки появляется после lazy-load;
            // повторный прогон навешивает клик на него, не дублируя десктопные.
            if (this.dataset.filtersSliderClickBound === '1') {
                return;
            }
            this.dataset.filtersSliderClickBound = '1';

            $(this).on('click', function() {
                const elRangeInput = $(this).siblings(SELECTORS.textInput);
                if (elRangeInput.length > 0) {
                    const sliderId = elRangeInput.attr('id');
                    const sliderInstance = state.priceRangeSliders[sliderId];
                    if (!sliderInstance) {
                        return;
                    }
                    processRangeSlideAction(state, sliderInstance.getValue(), sliderId, slideFilterFormButton);
                }
            });
        });
    };

    const initRangeInputSanitizer = () => {
        bindEvents([
            {
                target: document,
                events: 'keyup',
                selector: SELECTORS.rangeInput,
                handler: event => sanitizeRangeInput(event.target)
            }
        ]);
    };

    const initTouchHandlers = () => {
        bindEvents([
            {
                target: document,
                events: 'touchstart',
                selector: SELECTORS.sliderHandle,
                handler: event => {
                    event.cancelable && event.preventDefault();
                    const touch = event.originalEvent.touches[0];
                    event.currentTarget.dispatchEvent(
                        new MouseEvent('mousedown', {
                            clientX: touch.clientX,
                            clientY: touch.clientY
                        })
                    );
                }
            },
            {
                target: document,
                events: 'touchmove',
                selector: SELECTORS.slider,
                handler: event => {
                    event.cancelable && event.preventDefault();
                    const touch = event.originalEvent.touches[0];
                    const el = document.elementFromPoint(touch.clientX, touch.clientY);
                    if (el) {
                        el.dispatchEvent(
                            new MouseEvent('mousemove', {
                                clientX: touch.clientX,
                                clientY: touch.clientY
                            })
                        );
                    }
                }
            }
        ]);
    };

    const initFormsSubmit = currentUrl => {
        getFilterForm().submit(event => {
            event.preventDefault();

            const filterWrappers = $(SELECTORS.filterWrappers);
            disableFilterControls(filterWrappers);
            normalizePrefixedInputs($(event.currentTarget));

            const serializedArray = $(event.currentTarget)
                .serializeArray()
                .filter(item => item.value !== '');

            const formParams = new URLSearchParams();
            serializedArray.forEach(item => item.value && formParams.append(item.name, item.value));

            getFloatingFilterSubmit().remove();

            // Поисковый запрос (q) и сортировка (sort) живут в query текущего URL, а не в
            // полях формы фильтров. Переносим их в итоговый URL, иначе при применении фильтра
            // на странице поиска теряется сам запрос и выдача расширяется на весь каталог.
            const targetParams = new URLSearchParams(serializeFiltersToQuery(formParams));
            ['q', 'sort'].forEach(key => {
                if (!targetParams.has(key)) {
                    const value = currentUrl.searchParams.get(key);
                    if (value !== null && value !== '') {
                        targetParams.set(key, value);
                    }
                }
            });

            window.location.href =
                currentUrl.origin +
                currentUrl.pathname +
                '?' + targetParams.toString();
        });
    };

    const onPriceSlide = (val, id) => processRangeSlideAction(state, val, id, slideFilterFormButton);

    syncPriceBoundsFromDom();
    initRangeSliders(state, onPriceSlide);
    initNumericInputs();
    initFilterParamHandlers();
    initActiveFilters();
    initDeliveryFilter();
    initDeliveryFilterChipRemoval();
    initWarehouseFilter();
    initWarehouseFilterChipRemoval();
    initResetButtons();

    initSliderClickHandler();
    initRangeInputSanitizer();
    initTouchHandlers();

    addApplyFiltersButton();
    initFilterAccordions();

    const currentUrl = new URL(window.location.href);
    initFormsSubmit(currentUrl);

    // Слайдер цены и его обработчики живут в DOM модалки фильтров, которая на страницах
    // поиска и «Уценки» грузится лениво в #lazy-modals-root уже ПОСЛЕ этого init (см.
    // loadLazyModals в CustomerBundle/common.js). Слайдер-виджет делегированием не
    // навесить — его нужно инстанцировать на появившемся DOM. Доинициализируем контент
    // модалки по событию lazy-modals:loaded; все три вызова идемпотентны (guard в
    // initRangeSliders + per-element флаги), поэтому повторный прогон безопасен.
    const reinitLazyModalContent = () => {
        initRangeSliders(state, onPriceSlide);
        initNumericInputs();
        initSliderClickHandler();
    };

    document.addEventListener('lazy-modals:loaded', reinitLazyModalContent);

    // Модалка могла подгрузиться (preloadLazyModals → requestIdleCallback) ещё до
    // навешивания слушателя — если она уже в DOM, инициализируем сразу.
    if (document.querySelector(SELECTORS.filtersModal)) {
        reinitLazyModalContent();
    }
};

export default initProductFilters;
